import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from '@app-atr/app.component';
import { environment } from '@app-atr/environments/environment';

bootstrapApplication(AppComponent, appConfig(environment)).catch((err) => console.error(err));